<template>
<div class="text-xs-center">
  <v-dialog width="700" v-model="dialog">
    <v-progress-linear v-if="loading" :indeterminate="true">
    </v-progress-linear>
    <div v-else>
      <RelatedValueView v-if="relatedSchema && relatedValue" :relatedValue="relatedValue" :relatedSchema="relatedSchema" />
      <v-card v-else>
        <v-card-title>
          {{ $t('related.no_data') }}
        </v-card-title>
      </v-card>
    </div>
    <template v-slot:activator="{ on }">
      <v-btn @click="load()" v-on="on">{{ code }}</v-btn>
    </template>
  </v-dialog>
</div>
</template>

<script>
import http from '@/plugins/http'
import RelatedValueView from "@/components/related/value/ValueView"

export default {
  components: {
    RelatedValueView
  },
  props: ["code", "field"],
  computed: {
    relatedSchema() {
      try {
        return this.$store.state.relatedSchemas.find(relatedSchema => relatedSchema.id == this.relatedSchemaId)
      } catch (e) {
        return null
      }
    },
    locale: () => process.env.VUE_APP_LOCALE
  },
  data() {
    return {
      dialog: false,
      archvieCopy: {},
      loading: true,
      relatedSchemaId: 0,
      relatedValue: null,
      typeId: 0


    }
  },
  methods: {
    load() {
      this.dialog = true
      if (this.relatedValue == null) {
        http.get("related/group/type/" + this.typeId + "/value/code/" + this.code)
          .then(data => {
            this.relatedValue = data.data
            this.relatedSchemaId = data.data.related_schema_id
          })
          .catch(() => null)
          .finally(() => this.loading = false);
      }
    }
  },
  created() {
    if (this.field.options != undefined && this.field.options.group_type_id != undefined) {
      this.typeId = this.field.options.group_type_id
    }
  }
}
</script>

<style scope>
.radio>label {
  font-size: 11px !important;
}

.imageField {
  height: 100px;
  cursor: pointer;
  /*transform: rotate(-90deg);*/
}

.pointer {
  cursor: pointer;
}
</style>
